module.exports = require("@swa-ui/fetch");